import * as React from 'react';

export interface Props extends React.HTMLAttributes<HTMLTableRowElement> {
  items: React.ReactNode[];
  title: string;
}

export const TransactionInfo: React.FC<Props> = ({ title, items, ...props }) => (
  <tr {...props}>
    <td>{title}</td>
    {items.map((item, i) => (
      <td key={i}>{item}</td>
    ))}
  </tr>
);
